import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Import CSS here
// import "bootstrap/dist/css/bootstrap.min.css"
import "./assets/css/style.css"

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);